import {SubjectIdentity} from './models';

export class AddTestClosedEvent {
	constructor(public changedSubjectIds: number[], public lastSelectedSubject: SubjectIdentity) {
	}
}
